// Module
var code = `<template> <div id="chartdiv-\${id}" class="column flex-grow-1"></div> </template> `;
// Exports
module.exports = code;